"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxGroupItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _formContext = require("../form-context");

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckboxGroupItemComponent = function CheckboxGroupItemComponent(_ref) {
  var value = _ref.value,
      _onBlur = _ref.onBlur,
      props = _objectWithoutProperties(_ref, ["value", "onBlur"]);

  return _react["default"].createElement(_formContext.ContextCheckboxGroup.Consumer, null, function (checkboxApi) {
    if (!checkboxApi) {
      console.error('Could not found Checkbox Group API. Make sure <CheckboxGroupItem/> is in the <CheckboxGroup/>.');
      return null;
    }

    var name = checkboxApi.name,
        getValue = checkboxApi.getValue,
        setTouched = checkboxApi.setTouched,
        onChange = checkboxApi.onChange;
    var checked = getValue() || [];
    return _react["default"].createElement("input", _extends({}, props, {
      name: name,
      value: (0, _helpers.valueToJson)(value),
      checked: checked.length > 0 && getValue().includes(value),
      type: "checkbox",
      onChange: onChange,
      onBlur: function onBlur(event) {
        event.persist();
        setTouched(function () {
          if (_onBlur) {
            _onBlur(event);
          }
        });
      }
    }));
  });
};

CheckboxGroupItemComponent.displayName = 'CheckboxGroupItem';
var CheckboxGroupItem = CheckboxGroupItemComponent;
exports.CheckboxGroupItem = CheckboxGroupItem;